module.exports = __webpack_public_path__ + "images/icons_v2/brightness-high-dd9e9c7d.svg";